import React, { useState, useEffect } from "react";
import styles from "./ChangeUser.module.css";
import { Link } from "react-router-dom";
import { staticGameId } from "../../api-contants";

function ChangeUser(props) {
  const [screenName, setScreenName] = useState("");

  useEffect(() => {
    localStorage.removeItem("screenname");
  }, []);

  const { competition, currentOperator } = props;

  let gameId = staticGameId;
  if(competition && competition.template && competition.template.gameId) {
    gameId = competition.template.gameId;
  }

  let placeholder = "Jacob@ELK"
  let maxLength = 20
  if(currentOperator.name === "maple") {
    placeholder = "Firstname Lastname"
    maxLength = 100
  }

  return (
    <div className={`${styles.startscreencontainer}`}>
      <div
        className={`${styles.startscreenImage}`}
        style={{
          backgroundImage: `url(${require(`./../../img/Portrait-${gameId && typeof gameId === "number" ? gameId : "Default"}.jpg`)}`
        }}
      >
        <div className={styles.spacer}></div>
        <div className={`${styles.menu}`}>
          <div className={styles.heading}>Enter your screen name</div>
          <input
            label="name"
            placeholder={placeholder}
            className={styles.changeuserField}
            required
            maxLength={maxLength}
            onChange={e => setScreenName(e.target.value)}
          ></input>
          <div className={styles.subLabel}>(name@operator)</div>
          {screenName.length >= 3 ? (
            <Link
              // disabled={true}
              className={styles.btn}
              onClick={() => localStorage.setItem("screenname", screenName)}
              to={(props.currentOperator.id === 9990110 || props.currentOperator.id === 7770110)?`/`:`/${props.currentOperator.name}`}
            >
              Start
            </Link>
          ) : null}
        </div>
      </div>
    </div>
  );
}
export default ChangeUser;
